export default __webpack_public_path__ + "static/media/globogabipng.46053377.png";